const messageContainerStates = {
    mute_val: false,
    mute_other_val: 0,
    stashSelected: [],
    activeUser: null,
    convList: [],
    convIndex: null,
    showPrice: false,
    activeConv: null,
    msgOptionOpen: '',
    broadcastMsg: '',
    showMsgLoader: false,
    showImageModal: false,
    imageModalSrc: '',
    showBundleModal: false,
    bundleModalSrc: [],
    bundleIndex: 0,
    showVideoModal: false,
    showVerification: false,
    triggerScrollBottom: '',
    msgStats: {
        sent_num: '',
        read_num: '',
        paid_num: '',
        total_sales: '',
        total_earnings: '',
        is_bundle: 'no',
    },
    otherUserInformation: {},
    containerClass: '',
    stashModal: false,
    orderModal: false,
    activeAlbum: '',
    broadcastModal: false,
    sidebarBusy: false,
    messages: [],
    read: [],
    userFilter: 'all',
    messengerSearchFilter: '',
    broadcastIndicator: false,
    userListsFilter: [],
    showUserLists: false
};

export default messageContainerStates;
